const wallet = {
  'wallet.tips.error1': '用戶拒絕授權',
  'wallet.tips.error2': '{{msg}}。 請在10秒內切換',
  'wallet.logout.title': '註銷成功',
  'wallet.login.title': '登錄成功',
  'wallet.login.modal.tips': '以太坊新手？',
  'wallet.login.modal.learn': '了解更多關於錢包的信息',
  'wallet.login.btns': '連接錢包',
  'wallet.login.logout.tips': '註銷',
  'wallet.login.modal.title': '連接到錢包',
}

export default wallet
